import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useTranslation } from 'react-i18next';
import Avatar from 'assets/avatar.svg';
import { type UserProfileSummaryProps } from './types';

export const UserProfileSummary = ({
  firstName,
  surname,
  nickname,
  userId,
  enterpriseId,
  className,
}: UserProfileSummaryProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.PSYCHOLOGIST);

  return (
    <div className={cn('flex gap-4 items-center', className)}>
      <div className="w-18 h-18">
        <img src={Avatar} alt="Profile" className="rounded-full object-cover" />
      </div>
      <div>
        <p className="font-semibold text-lg">
          {firstName} {surname}
        </p>
        <p className="text-sm text-gray-600">
          {t('Chat.nickname.label', { ns: LOCIZE_NS.CHAT })} {nickname}
        </p>
        {userId && (
          <p className="text-sm text-gray-600 break-all">
            {t('PsychologistPatients.PatientProfile.userId.label')}
            {userId}
          </p>
        )}
        {enterpriseId && (
          <p className="text-sm text-gray-600 break-all">
            {t('PsychologistPatients.PatientProfile.enterpriseId.label')}
            {enterpriseId}
          </p>
        )}
      </div>
    </div>
  );
};
